import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TableCustom from '../../../components/table/tableCustom';
import { ButtonPrimary } from '../../../components/button/ButtonCustoms';
import ContentHeading from '../../../components/layout/content/ContentHeading';
import InputTextField from '../../../components/input/inputTextField';
import { SearchOutlined } from '@mui/icons-material';
import { createSearchParams, NavigateFunction, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { dateToView, timeToView } from '../../../utils/date.utils';
import { useDispatch } from 'react-redux';
import { alertActive, swalError, swalSuccess } from '../../../components/alert/swal';
import OptionsButtonCustom from '../../../components/button/OptionsButtonCustom';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { CalendarPicker, LocalizationProvider, PickersDay } from '@mui/x-date-pickers';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import thLocale from "date-fns/locale/th";
import { routeName } from '../../../routes/routeName';
import { ExaminationCalendarApi } from '../../../api/examination-calendar/examination-calendar.api';
import { ExaminationCalendarStudentViewApi } from '../../../api/examination-calendar-student-view/examination-calendar-student-view.api';
import moment from 'moment';
import StepperCustom from '../../../components/step/Stepper';
import StatusCustom from '../../../components/status/statusCustom';
import { renderStatus, status_e_the_sis_data } from '../../cms/EThesis/enum/enum';
import { debouncedApiCall } from '../../../utils/app.utils';
import StateComponents from '../../../components/state-component/StateComponents';
import { MENU_TYPE } from './enum';


const dayOfWeekFormatter = (day: any) => {
    const days: any = {
        "จ.": "จันทร์",
        "อ.": "อังคาร",
        "พ.": "พุธ",
        "พฤ.": "พฤหัสบดี",
        "ศ.": "ศุกร์",
        "ส.": "เสาร์",
        "อา.": "อาทิตย์",
    };
    return days[day] || day;
};
export default function StudentsScheduleCalenda() {
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const pathname = location.pathname;

    const [searchParams] = useSearchParams();
    const type_select = searchParams.get('type_select');

    const [tab, setTab] = useState<number>(0);

    const allStep: any[] = useMemo(() => [
        { name: t('ประกาศ'), isAccept: true, icon: null, disabled: false },
        { name: t('จองวันสอบ'), isAccept: true, icon: null, disabled: false },
    ], [t,]);


    useEffect(() => {
        if (type_select === MENU_TYPE.EXAM_BOOKING) {
            setTab(1);
        } else {
            setTab(0);
        }
    }, [type_select])

    return (
        <div>
            <ContentHeading
                title={t("ปฏิทินตารางการสอบ")}
                detail={t("กรุณาเลือกรายการที่ท่านต้องการ")}
            />
            <section style={{
                display: 'flex',
                justifyContent: 'center'
            }}>
                <StepperCustom
                    sx={{ maxWidth: "400px" }}
                    step={tab}
                    setStep={(num: number) => {
                        setTab(num);
                        if (num == 0) {
                            navigate({
                                pathname, search: createSearchParams({
                                    type_select: MENU_TYPE.ANNOUNCEMENT
                                }).toString()
                            }, { replace: true })
                        } else {
                            navigate({
                                pathname, search: createSearchParams({
                                    type_select: MENU_TYPE.EXAM_BOOKING
                                }).toString()
                            }, { replace: true })
                        }
                    }}
                    stepLabel={allStep}
                    view
                />
            </section>

            {tab === 0 &&
                <TapContentOne />
            }
            {tab === 1 &&
                <TapContentTwo />
            }
        </div>
    )
}

const TapContentOne = (props: any) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();

    const [date, setDate] = useState<any>(new Date());
    const [data, setData] = useState<any[]>([]);
    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {
                page: 1,
                pageLimit: 100,
                sdate: moment().startOf('month').format('YYYY-MM-DD'),
                edate: moment().endOf('month').format('YYYY-MM-DD'),

            };

            const res = await ExaminationCalendarApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items?.filter((item: any) => item?.examination_calendar_status !== 'DRAFT'));

                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    return (
        <div style={{ width: '100%' }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} locale={thLocale}>
                <Box sx={{
                    "& .MuiPickersDay-root": { width: "200px", height: '60px', fontSize: '16px' }, '& .MuiCalendarPicker-root': {
                        width: "100%",
                        height: 'auto',
                        maxHeight: 'none'
                    },
                    '& .MuiTypography-caption': {
                        width: "200px", height: '60px', fontSize: "16px", fontWeight: 'bold'
                    },
                    '& .MuiPickersCalendarHeader-label': {
                        fontSize: "18px", fontWeight: 'bold'
                    },
                    boxShadow: '0px 0px 8.8px 0px #00000026',
                    borderRadius: '16px',

                    gap: '20px',
                    marginTop: "20px",
                    marginBottom: '20px'
                }}>

                    <CalendarPicker
                        date={date}

                        onChange={(newDate) => { setDate(newDate) }}
                        views={["day"]}
                        disableFuture={false}
                        reduceAnimations
                        renderDay={(day, selectedDates, pickersDayProps) => {
                            const a = data?.filter((item: any) => dateToView(item?.examination_calendar_start_date) === dateToView(day))?.filter((item: any) => item?.examination_calendar_status === 'DRAFT')?.length
                            const b = data?.filter((item: any) => dateToView(item?.examination_calendar_start_date) === dateToView(day))?.filter((item: any) => item?.examination_calendar_status === 'WAITING_OPEN')?.length
                            const c = data?.filter((item: any) => dateToView(item?.examination_calendar_start_date) === dateToView(day))?.filter((item: any) => item?.examination_calendar_status === 'OPEN')?.length
                            const d = data?.filter((item: any) => dateToView(item?.examination_calendar_start_date) === dateToView(day))?.filter((item: any) => item?.examination_calendar_status === 'CLOSED')?.length
                            return (
                                <div style={{ position: 'relative' }}>
                                    <PickersDay
                                        {...pickersDayProps}
                                        sx={{
                                            borderRadius: '10px'
                                        }}
                                    />
                                    <div style={{ position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '10px' }}>
                                        {a > 0 && <div style={{ backgroundColor: '#B54708', color: '#fff', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%', fontSize: "12px" }}>{a}</div>}
                                        {b > 0 && <div style={{ backgroundColor: '#FFE097', color: '#fff', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%', fontSize: "12px" }}>{b}</div>}
                                        {c > 0 && <div style={{ backgroundColor: '#2186E3', color: '#fff', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%', fontSize: "12px" }}>{c}</div>}
                                        {d > 0 && <div style={{ backgroundColor: '#737373', color: '#fff', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: '50%', fontSize: "12px" }}>{d}</div>}
                                    </div>
                                </div>

                            );
                        }}
                        dayOfWeekFormatter={dayOfWeekFormatter}
                    />
                </Box>
            </LocalizationProvider>

            <div style={{ display: 'flex', gap: '20px' }}>
                <div style={{ display: 'flex' }}><Typography sx={{ color: "#FFE097", fontSize: "60px" }}>•</Typography><Typography>ยังไม่ถึงวันที่เปิดให้จอง</Typography></div>
                <div style={{ display: 'flex' }}><Typography sx={{ color: "#2186E3", fontSize: "60px" }}>•</Typography><Typography> เปิดให้จอง</Typography></div>
                <div style={{ display: 'flex' }}><Typography sx={{ color: "#737373", fontSize: "60px" }}>•</Typography><Typography> สิ้นสุดวันเปิดให้จอง</Typography></div>
            </div>

            <div>
                <div className='my-4'>
                    {data?.filter((item: any) => dateToView(item?.examination_calendar_start_date) === dateToView(date)).map((data: any, i: any) => {
                        return (
                            <div style={{
                                boxShadow: '0px 0px 8.8px 0px #00000026',
                                padding: '40px',
                                borderRadius: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '20px',
                                marginBottom: '20px'
                            }}>
                                <div style={{ display: 'flex', gap: '20px' }}>
                                    <div style={{ display: 'flex', borderRadius: '25px', backgroundColor: data?.examination_calendar_status === 'WAITING_OPEN' ? '#FFE097' : data?.examination_calendar_status === 'OPEN' ? '#2186E3' : '#737373', color: '#fff' }}>
                                        <StatusCustom
                                            sx={{ maxWidth: 200 }}
                                            // white_space='nowrap'
                                            text={renderStatus(data?.examination_calendar_status)} type={''} />
                                    </div>
                                </div>
                                <div>
                                    <Typography sx={{ fontWeight: '500', fontSize: '16px' }}>เรื่อง : {data?.examination_name}</Typography>
                                    {/* <Typography>วันที่เริ่มต้น : {dateToView(data?.examination_calendar_date)}</Typography> */}
                                    <Typography>วันที่เริ่มต้น-สิ้นสุดกิจกรรม : {dateToView(data?.examination_start_date)} - {dateToView(data?.examination_end_date)}</Typography>
                                    <Typography>เวลาเริ่มต้น-สิ้นสุดกิจกรรม :  {timeToView(data?.examination_start_date)} - {timeToView(data?.examination_end_date)} </Typography>
                                    <Typography>วันที่เริ่มต้น-สิ้นสุดการเปิดจอง :  {dateToView(data?.examination_calendar_start_date)} - {dateToView(data?.examination_calendar_end_date)} </Typography>
                                    <Typography>รายละเอียด : -</Typography>


                                </div>
                                <OptionsButtonCustom
                                    enableView

                                    // enableExamination
                                    enableEdit={data?.examination_calendar_status === 'OPEN'}
                                    onViewClick={() => {
                                        navigate(routeName.cms.DetailScheduleCalenda.replace(':id', data?.id_examination_calendar) + '?mode=VIEW')

                                    }}
                                    onEditClick={() => {
                                        navigate(routeName.students.StudentsAddExaminationCalendar, { state: data });
                                    }}

                                />
                                {/* <div style={{ display: "flex", justifyContent: 'space-between' }}>
                                    {data?.status === 'NOT_START_YET' ?
                                        <div style={{
                                            backgroundColor: '#FFFAEB',
                                            width: "100%",
                                            maxWidth: 250,
                                            minHeight: 30,
                                            display: 'flex',
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "8px 8px",
                                            borderRadius: '16px',
                                            wordBreak: "break-word", // ป้องกันข้อความล้น
                                            whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                        }}>
                                            <Typography sx={{ color: "#B54708" }}> {t('MEETING.MEETING_NOT_DUE_YET')}</Typography>
                                        </div> : <div style={{
                                            backgroundColor: '#ECFDF3',
                                            width: "100%",
                                            maxWidth: 250,
                                            minHeight: 30,
                                            display: 'flex',
                                            justifyContent: "center",
                                            alignItems: "center",
                                            padding: "8px 8px",
                                            borderRadius: '16px',
                                            wordBreak: "break-word", // ป้องกันข้อความล้น
                                            whiteSpace: "normal", // ให้ข้อความขึ้นบรรทัดใหม่
                                        }}>
                                            <Typography sx={{ color: "#0F9F0C" }}> {t('MEETING.MEETING_COMPLETED')}</Typography>
                                        </div>}
                                    <OptionsButtonCustom
                                        enableView
                                        enableEdit
                                        enableDelete
                                        onViewClick={() => {

                                        }}
                                        onCopy={() => {

                                        }}
                                        onEditClick={() => {
                                            // navigate(
                                            //     routeName.cms.CourseOfStudyDetail.replace(':id', id_course_of_study)
                                            // );
                                        }}
                                        onDeleteClick={() => {
                                            alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                                // handleDelete(id_course_of_study)
                                            })
                                        }} />
                                </div> */}

                            </div>
                        )
                    })}


                </div>
            </div>
        </div>
    )
}
const TapContentTwo = ({ }: any) => {
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const { t } = useTranslation();
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");

    const [search, setSearch] = useState<string>('')
    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [status, set_status] = useState<{ label: string, value: string }>();


    const handleDelete = async (id: any) => {
        await ExaminationCalendarStudentViewApi.delete(id).then((res: any) => {
            if (res.status < 300) {
                swalSuccess(t('ลบเอกสาร เรียบร้อยแล้ว'))
                loadData()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })

    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const headCells = [

        {
            id: "leave_type_name",
            width: '400px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: t("เรื่อง"),
        },

        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("วันที่เริ่มต้น-สิ้นสุดกิจกรรม"),
        },
        {
            id: "user_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("เวลาเริ่มต้น-สิ้นสุดกิจกรรม"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '250px',
            label: t("วันที่เริ่มต้น-สิ้นสุดการเปิดจอง"),
        },
        {
            id: "last_updated",
            disablePadding: false,
            align: "center",
            width: '200px',
            label: t("สถานะ"),
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "action",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { id_examination_calendar, id_examination_calendar_student, examination_name, examination_start_date, examination_end_date, examination_calendar_start_date, examination_calendar_end_date, examination_calendar_student_status, modified, modified_date } =
            objData;

        const objRenderData = {
            key: id_examination_calendar,
            id: no,
            obj: objData,
            columns: [

                {
                    option: "TEXT",
                    align: "start",
                    label: examination_name,
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: `${dateToView(examination_start_date)} - ${dateToView(examination_end_date)}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: `${timeToView(examination_start_date)} - ${timeToView(examination_end_date)}`,
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: `${dateToView(examination_calendar_start_date)} - ${dateToView(examination_calendar_end_date)}`,
                },

                {
                    option: "COMPONENT",
                    align: "center",
                    component:
                        <StatusCustom
                            sx={{ maxWidth: 200 }}
                            // white_space='nowrap'
                            text={renderStatus(examination_calendar_student_status)} type={''} />
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView
                            enableDelete

                            onViewClick={() => {
                                // navigate(routeName.cms.DetailScheduleCalenda.replace(':id', id_examination_calendar) + '?mode=VIEW')
                                navigate(routeName.cms.DetaiExamination.replace(':id', `${id_examination_calendar}`).replace(':id_examination_calendar_student', id_examination_calendar_student) + '?mode=VIEW')



                            }}

                            onEditClick={() => {
                                navigate(routeName.cms.DetailScheduleCalenda.replace(':id', id_examination_calendar))
                            }}
                            onDeleteClick={() => {
                                alertActive('ยืนยันที่จะลบ หรือไม่?', '', 'ยืนยัน', 'ยกเลิก', () => {
                                    handleDelete(id_examination_calendar_student)
                                })
                            }} />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };
            if (search) condition = { ...condition, keyword: search };
            if (start_date) condition.sdate = moment(start_date).format("YYYY-MM-DD");
            if (end_date) condition.sdate = moment(end_date).format("YYYY-MM-DD");
            if (status) condition.status = status?.value;
            const res = await ExaminationCalendarStudentViewApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, search, end_date, start_date, status]);

    useEffect(() => {
        loadData();
    }, [loadData]);



    return (
        <>
            <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12">
                    <InputTextField
                        startAdornment={<SearchOutlined />}
                        placeholder={t("ค้นหาชื่อเรื่อง")}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            debouncedApiCall({ searchItem: e.target.value, setItem: setSearch });
                            // handleChangeValueSearch("leave_type_name", e.target.value);
                        }}
                    // value={inputValueSearch.leave_type_name}
                    />


                </article>
                {/* <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    
                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    />


                </article> */}
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    {/* <InputDatePicker
                        helperText={""}
                        allowClear
                        disableFuture
                        onChange={(e: any) => {
                            // handleChangeValueSearch("date", moment(e).format("YYYY-MM-DD"));
                        }} value={undefined} /> */}

                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12
                                },
                                type: "DATE_RANGE2",
                                fieldProps: {
                                    placeholder: "ช่วงวันที่",
                                    handleChange: (st, end) => {
                                        set_start_date(st ?? "");
                                        set_end_date(end ?? "");
                                    },
                                    value: {
                                        end_date,
                                        start_date
                                    }
                                }
                            }
                        ]}

                    />
                </article>
                <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                    {/* 
                    <FilterSelect
                        // value={inputValueSearch.year ?? ""}
                        labelId="year-id"
                        selectId="year-select-id"
                        options={[].map((year: any, index: number) => (
                            <MenuItem value={year} key={index + 1}>
                                {year}
                            </MenuItem>
                        ))}
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => { }
                            // handleChangeValueSearch("year", e.target.value)
                        }
                    /> */}
                    <StateComponents
                        typeProps={[
                            {
                                seq: 1,
                                gridProps: {
                                    xs: 12,
                                },
                                type: "AUTO-COMPLETE",
                                fieldProps: {
                                    getOptionLabel: (op) => op?.label || "",
                                    labelId: "DWAD",
                                    onChange: (_, val) => set_status(val ?? null),
                                    placeholder: "ทุกสถานะ",
                                    options: status_e_the_sis_data || [],
                                    value: status || null
                                }
                            },
                        ]}
                    />

                </article>

                <article
                    className="w-full col-span-12 md:col-span-4 lg:col-span-4 sm:col-span-12"
                    style={{
                        display: "flex",
                        justifyContent: "end",
                    }}
                >
                    <ButtonPrimary
                        onClick={() => {
                            navigate({
                                pathname: routeName.students.StudentsAddExaminationCalendar, search: createSearchParams({
                                    type_select: MENU_TYPE.EXAM_BOOKING
                                }).toString()
                            });
                        }}
                        mode="add"
                        buttonName={t("ส่งเรื่องขอจองวันสอบ")}
                    />
                </article>
            </div>

            <section className="w-full mt-10">
                <TableCustom
                    tableMinWidth={1840}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </>
    )
}